<template>
  <div>
    <div class="upload-box">
      <!--upload-->
      <div class="up-box" v-if="!localFile && !temp.status">
        <label>
          <i class="fas fa-upload"></i>
          <input
            hidden
            type="file"
            accept=".png, .jpg, .jpeg, .gif, .svg, .bmp, .webp"
            @change="upload"
          />
        </label>
      </div>

      <!--show image-->
      <div class="image-box" v-if="localFile && !temp.status">
        <div class="image">
          <template v-if="temp.path != null">
            <img :src="temp.path" />
          </template>
          <template v-else>
            <img :src="localFile" />
          </template>
        </div>
        <div class="option">
          <button v-if="editable" type="button" @click="deleteImage(localFile)">
            <i class="fas fa-trash"></i>
          </button>
          <button type="button" @click="showImage()">
            <i class="fas fa-eye"></i>
          </button>
        </div>
      </div>

      <!--temp-->
      <div class="image-box" v-if="temp.status">
        <div class="image">
          <div
            class="uploadPercentage"
            v-show="temp.uploadPercentage && temp.uploadPercentage < 100"
            v-html="temp.uploadPercentage + ' %'"
          ></div>
          <template v-if="temp.path != null">
            <img :src="temp.path" />
          </template>
          <template v-else>
            <img :src="localFile" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localFile: this.file,
      temp: {
        status: false,
        uploadPercentage: 0,
        path: null,
      },
    };
  },
  watch: {
    file(newFile) {
      this.localFile = newFile;
    },
  },
  methods: {
    upload(e) {
      const image = e.target.files[0];
      this.localFile = image;
      this.temp.path = (window.URL || window.webkitURL).createObjectURL(image);
      this.$emit("update:file", image);
    },
    async showImage() {
      await this.$swal({
        imageUrl: this.temp.path || this.localFile,
        confirmButtonText: "باشه",
      });
    },
    async deleteImage() {
      let prompt = await this.$swal({
        type: "warning",
        title: "حذف ",
        text: "آیا از حذف این آیتم اطمینان دارید",
        confirmButtonText: "بله حذف شود",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "خیر",
      });

      if (prompt.value) {
        this.localFile = null;
        this.$emit("update:file", "");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.upload-box {
  border: 1px solid rgba(127, 130, 139, 0.24);
  width: 100%;
  height: auto;
  border-radius: 5px;
  display: flex;
  justify-content: left;
  align-items: center;
  flex-flow: wrap;

  .up-box {
    label {
      margin: 10px;
      background-color: rgba(171, 171, 171, 0.17);
      width: 110px;
      height: 110px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      input[type="file"] {
        display: none;
      }

      i {
        color: #9ea1aa;
        font-size: 30px;
      }
    }
  }

  .image-box {
    background-color: rgba(171, 171, 171, 0.17);
    width: 110px;
    height: 110px;
    border-radius: 10px;
    padding: 5px 0 0 0;
    margin: 10px;
    overflow: hidden;
    transition: 0.3s;

    .image {
      width: 100px;
      height: 100px;
      margin: 0 auto;
      overflow: hidden;
      transition: 0.3s;
      position: relative;

      img {
        border-radius: 10px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .uploadPercentage {
        border-radius: 50px;
        background-color: rgb(255, 255, 255);
        position: absolute;
        display: flex;
        color: #000000;
        justify-content: center;
        align-items: center;
        width: 70%;
        height: 70%;
        left: 15%;
        right: 15%;
        top: 15%;
        bottom: 15%;
      }
    }

    &:hover {
      .image {
        margin-top: -25px;
        transition: 0.3s;
      }

      .option {
        transition: 0.3s;
        opacity: 1;
      }
    }

    .option {
      transition: 0.3s;
      opacity: 0;
      display: flex;
      justify-content: center;
      padding: 5px;

      button {
        border: 0px;
        margin: 0 3px;

        i {
          color: #8f929b;

          &:hover {
            color: #6d6d6d;
            animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
            transform: translate3d(0, 0, 0);
            backface-visibility: hidden;
            perspective: 1000px;
          }
        }
      }
    }
  }
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-0.5px, 0, 0) rotate(-10deg);
  }

  20%,
  80% {
    transform: translate3d(1px, 0, 0) rotate(10deg);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-2px, 0, 0) rotate(-10deg);
  }

  40%,
  60% {
    transform: translate3d(2px, 0, 0) rotate(10deg);
  }
}
</style>
